<template>
  <div class="form-base">
    <v-tabs v-model="tab" ref="tabs" grow class="tabs-base">
      <v-tab>Сведения о доверенности</v-tab>
      <v-tab>Сведения о доверителях</v-tab>
      <v-tab>Сведения о доверенных лицах</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <ProxyInfo :v="v" />
      </v-tab-item>

      <v-tab-item eager>
        <ProxyTrustee
          ref="trusties"
          v-for="(vTrustee, i) in v.trusties.$each.$iter"
          :v="vTrustee"
          :key="`trusties ${i}`"
          :can-delete="v.trusties.$model.length > 1"
          @delete="$emit('delete-proxy-trustee', i)"
        />

        <div class="py-8">
          <v-btn
            @click="$emit('add-proxy-trustee')"
            depressed
            color="primary"
            class="button-base"
          >
            Добавить доверителя
          </v-btn>
        </div>
      </v-tab-item>

      <v-tab-item eager>
        <ProxyPerson
          ref="proxyPersons"
          v-for="(vProxyPerson, i) in v.proxyPersons.$each.$iter"
          :v="vProxyPerson"
          :key="`proxyPersons ${i}`"
          :can-delete="v.proxyPersons.$model.length > 1"
          @delete="$emit('delete-proxy-person', i)"
        />

        <div class="py-8">
          <v-btn
            @click="$emit('add-proxy-person')"
            depressed
            color="primary"
            class="button-base"
          >
            Добавить доверенное лицо
          </v-btn>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mdiAlertCircleOutline } from '@mdi/js';
import cloneDeep from 'clone-deep';
import { getValidationErrorText } from '@/utils/validate';
import ProxyTrustee, {
  proxyTrusteeModel,
  proxyTrusteeValidation,
} from './ProxyTrustee/ProxyTrustee';
import ProxyPerson, {
  proxyPersonModel,
  proxyPersonValidation,
} from './ProxyPerson/ProxyPerson';
import ProxyInfo, {
  proxyInfoModel,
  proxyInfoValidation,
} from '@/components/services/ROD/StepProxy/ProxyInfo';
import { DocumentType } from '@/types/services';

export const proxyModel = {
  number: 1,
  ...proxyInfoModel,
  trusties: [cloneDeep(proxyTrusteeModel)],
  proxyPersons: [cloneDeep(proxyPersonModel)],
};

export const proxyValidation = {
  number: {},
  ...proxyInfoValidation,
  trusties: {
    $each: proxyTrusteeValidation,
  },
  proxyPersons: {
    $each: proxyPersonValidation,
  },
};

export default {
  name: 'Proxy',
  props: {
    v: {
      type: Object,
      required: true,
    },
    canDelete: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    ProxyTrustee,
    ProxyPerson,
    ProxyInfo,
  },
  data: () => ({
    DocumentType,
    getValidationErrorText,
    mdiAlertCircleOutline,
    tab: null,
  }),
};
</script>
